import {Fragment} from 'react';
import './index.css';




function AndroidPageParis() {
    window.location.href = 'https://milocal-txd.web.app/android-paris';
    return <div className='content-page'>
        <div className="android-page">
            <div className="content">
                <img className='mb-2' src="assets/img/paris/android/logo.svg" alt=""/>
                <img src="assets/img/paris/android/txt.svg" alt=""/>
                <a className='btndownload'
                   href="https://ux-cdn.cencosudx.io/milocal/txd/milocal-v1.5.0.apk"
                   target="_self">
                    <img src="assets/img/paris/android/3.svg" alt=""/>
                </a>
                <img className='mb-2 card' src="assets/img/android-sm/3.png" alt=""/>
                <img className='mb-2 card' src="assets/img/android-sm/4.png" alt=""/>
                <img className='mb-2 card' src="assets/img/android-sm/5.png" alt=""/>
                <img className='mb-2' src="assets/img/paris/android/4.svg" alt=""/>
            </div>
            
        </div>
        <img className='footer' src="assets/img/paris/android/footer.svg" alt=""/>
    </div>
}

export default AndroidPageParis;